// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc4c33eb","667":"eb36434e"}[chunkId] + ".chunk.js";
};